module.exports = __webpack_public_path__ + "static/media/logo-green-small-2x.888043d5.png";